import {
  DeliverySVGIcon,
  OrderTableSvgIcon,
  TopCitySVGIcon,
} from '@/assets/svg'
import { WrapperCard } from '@/components/fragments'
import {
  useGetCustomerDashboardQuery,
  // useGetCustomerDashboardStatsQuery,
} from '@/redux/services/customer'
import {
  ApplicationTrendsSkeleton,
  DashboardStatsSkeleton,
  RestaurantPerformanceSkeleton,
} from '@/skeletons'
import routesPath from '@/utils/routesPath'
import { useNavigate } from 'react-router-dom'
import DashboardLayout from '../app-layout'
import { CustomerPerformanceChart } from './components/performance-pie-chart'
import { LineChart } from './components'
import { useMemo } from 'react'
import CustomerListPage from './components/customer-list'

const { CUSTOMER_LIST } = routesPath

export default function CustomersPage() {
  // const { data: dashboardStats, isLoading: isLoadingDashboard } =
  // useGetCustomerDashboardStatsQuery({})
  const { data: dashboardOverview, isLoading: isLoadingOverview } =
    useGetCustomerDashboardQuery({})

  const navigate = useNavigate()

  // Transform order_behavior data for the performance chart
  const performanceData = useMemo(() => {
    if (!dashboardOverview?.order_behavior) return undefined
    return {
      repeat_restaurants: {
        count: dashboardOverview.order_behavior.repeat_customers?.count || 0,
        percentage:
          dashboardOverview.order_behavior.repeat_customers?.percentage || 0,
      },
      first_time_restaurants: {
        count: dashboardOverview.order_behavior.first_time_users?.count || 0,
        percentage:
          dashboardOverview.order_behavior.first_time_users?.percentage || 0,
      },
    }
  }, [dashboardOverview])

  // Transform weekly_acquisition_trend for the line chart (Weekly view)
  const weeklyChartData = useMemo(() => {
    if (!dashboardOverview?.weekly_acquisition_trend) return []
    return dashboardOverview.weekly_acquisition_trend.map(
      (item: { day: string; count: number }) => ({
        day: item.day,
        applications: item.count,
      }),
    )
  }, [dashboardOverview])

  // Transform monthly_acquisition_trend for the line chart (Monthly view)
  const monthlyChartData = useMemo(() => {
    if (!dashboardOverview?.monthly_acquisition_trend) return []
    return dashboardOverview.monthly_acquisition_trend.map(
      (item: {
        month: string
        year: number
        label: string
        count: number
      }) => ({
        month: item.label,
        applications: item.count,
      }),
    )
  }, [dashboardOverview])

  return (
    <DashboardLayout pageTitle='Customer Management'>
      <section className='w-full h-fit space-y-5 mb-5'>
        {isLoadingOverview ? (
          <DashboardStatsSkeleton />
        ) : (
          <div className='w-full grid md:grid-cols-3 gap-6'>
            <WrapperCard
              title='Total Customers'
              icon={OrderTableSvgIcon}
              headerClassName='justify-between flex-row items-center gap-x-2'
              wrapperClassName='px-0 p-5'
              total={dashboardOverview?.total_customers?.toString() || '0'}
              isTrend={true}
              trend={'Active Customers'}
              // trendClass={
              //   dashboardStats?.total_orders?.change_type === 'positive'
              //     ? '!text-green-500'
              //     : '!text-red-500'
              // }
              loading={false}
            />
            <WrapperCard
              title='Top City'
              icon={TopCitySVGIcon}
              headerClassName='justify-between flex-row items-center gap-x-2'
              wrapperClassName='px-0 p-5'
              total={dashboardOverview?.top_city?.city || '0'}
              isTrend={true}
              trend={
                dashboardOverview?.top_city?.count?.toString() + ' Customers' ||
                '----'
              }
              loading={false}
            />
            <WrapperCard
              onClick={() => navigate(CUSTOMER_LIST)}
              title='Waiting List'
              icon={DeliverySVGIcon}
              headerClassName='justify-between flex-row items-center gap-x-2'
              wrapperClassName='p-5 min-h-[10rem] cursor-pointer bg-[#295532] text-white'
              total={dashboardOverview?.waiting_list?.toString() || '0'}
              isTrend={true}
              trendClass='text-white'
              trendCountClass='text-white'
              loading={false}
              trend={'Registered Customers'}
            />
          </div>
        )}
      </section>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        {isLoadingOverview ? (
          <RestaurantPerformanceSkeleton />
        ) : (
          <div className='bg-white rounded-[1.15rem] flex flex-col justify-between'>
            <WrapperCard
              title='Order Behavior Patterns'
              icon={OrderTableSvgIcon}
              headerClassName='justify-between flex-row items-center gap-x-2'
              wrapperClassName='px-0 p-5'
            >
              <CustomerPerformanceChart data={performanceData} />
            </WrapperCard>
          </div>
        )}

        {isLoadingOverview ? (
          <ApplicationTrendsSkeleton />
        ) : (
          <div className='bg-white rounded-[1.15rem] p-5 min-h-fit flex flex-col justify-between'>
            <div className='flex justify-between items-center'>
              <span className='text-[1.1rem] SFPro-Semibold font-bold tracking-wider'>
                Customer Acquisition Trends
              </span>
              <div className='flex items-center gap-2'>
                <span className='bg-gray-50 p-2 rounded-full'>
                  <figure>{TopCitySVGIcon}</figure>
                </span>
              </div>
            </div>
            <LineChart
              showChart={true}
              onTimePeriodChange={() => {}}
              weeklyChartData={weeklyChartData}
              monthlyChartData={monthlyChartData}
            />
          </div>
        )}
      </div>
      <CustomerListPage />
    </DashboardLayout>
  )
}
